import React from 'react';
import { InstagramIcon, TwitterIcon, YoutubeIcon } from 'lucide-react';
const Footer = () => {
  return <footer className="py-12 relative z-10" data-id="element-209">
      <div className="container mx-auto px-6" data-id="element-210">
        <div className="flex flex-col items-center" data-id="element-211">
          <div className="flex space-x-8 mb-8" data-id="element-212">
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-pink-400 transition-colors transform hover:scale-110 duration-300" aria-label="Instagram" data-id="element-213">
              <InstagramIcon size={28} data-id="element-214" />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-pink-400 transition-colors transform hover:scale-110 duration-300" aria-label="Twitter" data-id="element-215">
              <TwitterIcon size={28} data-id="element-216" />
            </a>
            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-pink-400 transition-colors transform hover:scale-110 duration-300" aria-label="YouTube" data-id="element-217">
              <YoutubeIcon size={28} data-id="element-218" />
            </a>
            <a href="https://open.spotify.com/artist/1eBlIKgOfnWYuzUVRNpmNT" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-pink-400 transition-colors transform hover:scale-110 duration-300" aria-label="Spotify" data-id="element-219">
              {/* Custom Spotify Icon since it's not in lucide-react */}
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-220">
                <circle cx="12" cy="12" r="10" data-id="element-221"></circle>
                <path d="M8 11.2a5.6 5.6 0 0 1 5.6-1" data-id="element-222"></path>
                <path d="M6 9.5a8 8 0 0 1 8.7-1" data-id="element-223"></path>
                <path d="M9 13.5a3 3 0 0 1 3-.5" data-id="element-224"></path>
              </svg>
            </a>
          </div>
          <div className="w-24 h-1 bg-gradient-to-r from-pink-500/30 to-purple-500/30 rounded-full mb-8" data-id="element-225"></div>
          <p className="text-gray-500 text-sm" data-id="element-226">
            © {new Date().getFullYear()} Fabric Reality. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>;
};
export default Footer;